import React from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Box, Divider, Grid, Paper, Typography } from '@material-ui/core' //Divider
import CircularProgress from '@material-ui/core/CircularProgress'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import Plot from 'react-plotly.js'

import Spinner from '../Spinner'
import NotFound from '../NotFound'
import Beta from '../widgets/Beta'
import { AUDIENCE_ACQUISITION, AUDIENCE_MAINTENANCE } from '../../constants/module_info'

import './AudienceAcquisitionComponent.scss'
import { theme } from '../../classes/Themes'
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../classes/Styles'
import { ACQUISITION, ACQUISITION_HOVER_TITLE, ACQUISITION_TITLE, AUDIENCE_DRIVER_MODULE, MAINTENANCE, MAINTENANCE_HOVER_TITLE, MAINTENANCE_TITLE } from '../../constants/commons'
import Profile from '../../classes/profile'
import GoogleAnalytics from '../../classes/GoogleAnalytics'

class AcquisitionRollingComponent extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    history: PropTypes.object,
    profile: Profile.PropTypes,
    location: PropTypes.object,
    homepage: PropTypes.object,
    classes: PropTypes.object.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    audienceAcquisition: PropTypes.object
  }

  constructor (props) {
    super(props)

    this.state = {
      audienceAcquisition: {
        isFetching: false,
        error: null,
        selectedNetwork: ''
      },
      page: 0,
      colors: ['#6372F2', '#DE5F46', '#5BC89A', '#AD62FA', '#FFA059', '#61D1EF', '#FF6693', '#B6E77E', '#FF96FD', '#FBCB52']
    }
  }

  componentDidMount () {
    GoogleAnalytics.trackGA(AUDIENCE_DRIVER_MODULE, this.props.location, this.props.profile)
  }

  componentDidUpdate (prevProps) {
    if (prevProps.audienceAcquisition !== this.props.audienceAcquisition) {
      this.handleChangePage(0)
    }

    if (prevProps.audienceAcquisition != this.props.audienceAcquisition && this.props.audienceAcquisition.details) {
      this.setState({ selectedNetwork: this.props.audienceAcquisition.details.audience_acquisition_network && this.props.audienceAcquisition.details.audience_acquisition_network.display_name})
    }
  }

  setSelectedNetwork = (network) => {
    this.setState({ selectedNetwork: network })
  }

  handleChangePage = page => {
    this.setState({ page: page})
  }

  render () {
    const { classes } = this.props
    if (this.props.homepage.isFetching) {
      return (<Spinner />)
    }

    if (this.props.homepage.error || (!this.props.homepage.isFetching && this.props.homepage.details && this.props.homepage.details.network_entities && this.props.homepage.details.network_entities.length === 0)) {
      return (<NotFound isAdmin={this.props.isAdmin}/>)
    }

    return (
      <>
        <Grid container spacing={0} className="mt-1" id='audienceAcquisition'>
          <Grid item xs={12} lg={12} md={12} sm={12}
            style={{transition: theme.transitions.create('all', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen
          })}}>
            <Paper className="cardBase cardHeight">
              <Grid container direction="column">
                <Grid item className='cardPadding'>
                  <span className="cardTitle">{ACQUISITION}<Beta color='#A9A9A9'/></span>
                  <OverlayTrigger overlay={<Tooltip id="tooltip">{AUDIENCE_ACQUISITION}</Tooltip>} placement="right">
                    <img src="/static/images/info.png" alt="info" className="cardInfo" />
                  </OverlayTrigger>
                </Grid>
                <Grid item className="cardSubTitle">Shows and movies that have added the greatest proportion of new engagers (rolling 90 day view)</Grid>
                { ((this.props.audienceAcquisition && this.props.audienceAcquisition.isFetching) || (this.props.audienceAcquisition && this.props.audienceAcquisition.details && this.props.audienceAcquisition.details.audience_acquisition.length === 0)) &&
                  <div className='loadingProgress'>
                    <CircularProgress />
                  </div>
                }
                { (this.props.audienceAcquisition && this.props.audienceAcquisition.details && this.props.audienceAcquisition.details.audience_acquisition.length > 0) &&
                  <AudienceAcquisition
                    classes={this.props.classes}
                    audienceAcquisition={this.props.audienceAcquisition}
                    colors={this.state.colors}
                    module={ACQUISITION}
                  />
                }
              </Grid>
            </Paper>
          </Grid>
        </Grid>
        <Grid container spacing={0} className={classes.audienceAcquisitionHeader} id='audienceAcquisition'>
          <Grid item xs={12} lg={12} md={12} sm={12}
            style={{transition: theme.transitions.create('all', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen
          })}}>
            <Paper className="cardBase cardHeight">
              <Grid container direction="column">
                <Grid item className='cardPadding'>
                  <span className="cardTitle">{MAINTENANCE}<Beta color='#A9A9A9'/></span>
                  <OverlayTrigger overlay={<Tooltip id="tooltip">{AUDIENCE_MAINTENANCE}</Tooltip>} placement="right">
                    <img src="/static/images/info.png" alt="info" className="cardInfo" />
                  </OverlayTrigger>
                </Grid>
                <Grid item className="cardSubTitle">Shows and movies that engaged the greatest proportion of the active audience (rolling 90 day view)</Grid>
                { ((this.props.audienceAcquisition && this.props.audienceAcquisition.isFetching) || (this.props.audienceAcquisition && this.props.audienceAcquisition.details && this.props.audienceAcquisition.details.audience_maintenance.length === 0)) &&
                  <div className='loadingProgress'>
                    <CircularProgress />
                  </div>
                }
                { (this.props.audienceAcquisition && this.props.audienceAcquisition.details && this.props.audienceAcquisition.details.audience_maintenance.length > 0) &&
                  <AudienceAcquisition
                    classes={this.props.classes}
                    audienceAcquisition={this.props.audienceAcquisition}
                    colors={this.state.colors}
                    module={MAINTENANCE}
                  />
                }
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </>
    )
  }
}


export class AudienceAcquisition extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    audienceAcquisition: PropTypes.object,
    colors: PropTypes.array,
    module: PropTypes.string
  }

  constructor (props) {
    super(props)

    this.state = {
      layout: null,
      config: {
          responsive: true,
          displaylogo: false,
          modeBarButtonsToRemove: ['toImage', 'autoScale2d', 'toggleSpikelines', 'hoverCompareCartesian', 'hoverClosestCartesian'],
          displayModeBar: false
      },
      data: [],
      audienceAcquisition: [],
      toggleNewEngager: false
   }
  }

  componentDidMount () {
    this.setData()
  }

  componentDidUpdate (prevProps, prevState) {
    if ((prevProps.audienceAcquisition !== this.props.audienceAcquisition && this.props.audienceAcquisition.details) || (prevState.toggleNewEngager !== this.state.toggleNewEngager)) {
      this.setData()
    }
  }

  setData = () => {
    const { module } = this.props
    let audienceAcquisition = []
    if (module === ACQUISITION) {
      audienceAcquisition = this.props.audienceAcquisition.details && this.props.audienceAcquisition.details.audience_acquisition ? this.props.audienceAcquisition.details.audience_acquisition : []
    } else if (module === MAINTENANCE) {
      audienceAcquisition = this.props.audienceAcquisition.details && this.props.audienceAcquisition.details.audience_maintenance
    }
    audienceAcquisition = audienceAcquisition.reduce((unique, o) => {
      if (!unique.some(obj => obj.name === o.name)) {
        unique.push(o)
      }
      return unique
    }, [])
    audienceAcquisition = audienceAcquisition ? audienceAcquisition.sort((a, b) => b.data.x - a.data.x) : audienceAcquisition
    audienceAcquisition = audienceAcquisition && audienceAcquisition.length > 0 ? audienceAcquisition.slice(0, 20) : audienceAcquisition
    if (audienceAcquisition && audienceAcquisition.length > 0) {
      audienceAcquisition = this.state.toggleNewEngager ? audienceAcquisition.slice(10, 20) : audienceAcquisition.slice(0, 10)
    }
    const minXVal = audienceAcquisition && audienceAcquisition.length> 0 && audienceAcquisition.map(aa => aa.data.x).reduce((a, b) => {
      return Math.min(a, b)
    })
    const maxXVal = audienceAcquisition && audienceAcquisition.length> 0 && audienceAcquisition.map(aa => aa.data.x).reduce((a, b) => {
      return Math.max(a, b)
    })
    const maxYVal = audienceAcquisition && audienceAcquisition.length> 0 && audienceAcquisition.map(aa => aa.data.y).reduce((a, b) => {
      return Math.max(a, b)
    })
    let yVals = []
    for (let i = 0; i <= 100; i = i+5) {
      yVals.push(i)
    }
    yVals = yVals.filter(y => y >= minXVal - 5 || y >= minXVal)
    let xAxisValues =[]
    let yAxisValues = []
    let name = []
    let hoverText = []
    let dataArr = {}
    const type = module === ACQUISITION ? 'New' : 'Engaged'
    audienceAcquisition && audienceAcquisition.map(aa => {
      xAxisValues.push(aa.data.x)
      yAxisValues.push(aa.data.y)
      name.push(aa.name)
      hoverText.push(`Size: ${aa.data.y <= maxYVal/3 ? 'S' : aa.data.y <= (maxYVal/3) * 2 ? 'M' : 'L'}  <span style={display: "flex"; align-items: "center"; height: "200px";}><b>.</b></span>  ${type}: ${aa.data.x <= maxXVal/3 ? 'S' : aa.data.x <= (maxXVal/3) * 2 ? 'M' : 'L'}`)
      dataArr = {
        type: 'scattergl',
        mode: 'markers',
        x: xAxisValues,
        y: yAxisValues,
        text: name,
        customdata: hoverText,
        marker: { size: 6, color: this.props.colors},
        hovertemplate:
          '<b>%{text}</b><br>' +
          '%{customdata}' +
          '<extra></extra>'
      }
    })
    this.setState({
      data: [ dataArr ],
      audienceAcquisition: audienceAcquisition,
      layout: {
        width: this.state.width,
        height: 240,
        autosize: true,
        margin: {l: 10, r: 10, b: 10, t: 20},
        hovermode: 'closest',
        hoverlabel: {
          align: 'left'
        },
        showlegend: false,
        legend: {orientation: 'h', y: -0.3},
        xaxis: {
          color: '#A7A9AC',
          showline: true,
          linecolor: '#A7A9AC',
          showgrid: true,
          zeroline: false,
          visible: true,
          automargin: true,
          title: {
            text: module === ACQUISITION ? ACQUISITION_HOVER_TITLE : MAINTENANCE_HOVER_TITLE,
            font: {
              family: 'Uni Sans Book',
              size: 14,
              color: '#A7A9AC'
            }
          },
          tickvals: [0, maxXVal/3, maxXVal/3 * 2, maxXVal],
          ticktext: ['0', 'S', 'M', 'L']
        },
        yaxis: {
          color: '#A7A9AC',
          showline: true,
          linecolor: '#A7A9AC',
          showgrid: true,
          zeroline: false,
          visible: true,
          automargin: true,
          type: 'linear',
          autorange: true,
          title: {
            text: 'Audience Size',
            font: {
              family: 'Uni Sans Book',
              size: 14,
              color: '#A7A9AC'
            }
          },
          tickmode: 'array',
          tickvals: [0, maxYVal/3, maxYVal/3 * 2, maxYVal],
          ticktext: ['0', 'S', 'M', 'L']
        }
      }
    })
  }

  handleNewEngager = () => {
    const currentStatus = this.state.toggleNewEngager
    this.setState({
      toggleNewEngager: !currentStatus
    })
  }

  render () {
    const { classes } = this.props
    return (
      <Grid container direction="row" className={classes.audienceAcquisitionHeader}>
        <Grid item xs={12} lg={6} md={12} sm={12}>
          <Plot
            data = {this.state.data}
            layout={this.state.layout}
            config={this.state.config}
            useResizeHandler
            style={{ width: '100%', height: '100%' }}
          />
        </Grid>
        <Grid item xs={12} lg={1} md={12} sm={12} className='aaDivider'>
          <Divider orientation="vertical" flexItem />
        </Grid>
        <Grid item xs={12} lg={5} md={12} sm={12}>
          <NewEngager
            classes={this.props.classes}
            handleNewEngager={this.handleNewEngager}
            audienceAcquisition={this.state.audienceAcquisition}
            toggleNewEngager={this.state.toggleNewEngager}
            module={this.props.module}/>
        </Grid>
      </Grid>
    )
  }
}

export class NewEngager extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    audienceAcquisition: PropTypes.array,
    toggleNewEngager: PropTypes.bool,
    handleNewEngager: PropTypes.func,
    module: PropTypes.string
  }

  render () {
    const { classes, toggleNewEngager, module } = this.props
    const audienceAcquisition = this.props.audienceAcquisition ? this.props.audienceAcquisition : []
    let sliceData = audienceAcquisition.slice(0, 5)
    let sliceData1 = audienceAcquisition.slice(5, 10)
    const title = module === ACQUISITION ? ACQUISITION_TITLE : MAINTENANCE_TITLE
    return (
      <Grid item container direction="column" justify="center" spacing={1} className={classes.audienceAcquisitionHeader}>
        <Grid item className={classes.AcquisitionPremiereComponent}>{title}</Grid>
        <Grid item className={classes.viewershipNetwork}>
          <ul className={classes.viewershipNetworkList}>
            { sliceData.map((data, index) => {
                return (
                  <li className={classes.viewershipNetworkLists} key={`${data.name}_top_${index}`}>
                    <span className={classes.viewershipNetworkListSpan}>
                      <span className={`${classes.viewershipCircle} ${index === 0 ? classes.newEngagerCircle0 : index === 1 ? classes.newEngagerCircle1 : index === 2 ? classes.newEngagerCircle2 : index === 3 ? classes.newEngagerCircle3 : index === 4 ? classes.newEngagerCircle4 : ''}`}></span>
                      <span>{data.name}</span>
                    </span>
                  </li>
                )
              })
            }
          </ul>
          <ul className={classes.viewershipNetworkList}>
            { sliceData1.map((data, index) => {
                return (
                  <li className={classes.viewershipNetworkLists} key={`${data.name}_bottom_${index}`}>
                    <span className={classes.viewershipNetworkListSpan}>
                      <span className={`${classes.viewershipCircle} ${index === 0 ? classes.newEngagerCircle5 : index === 1 ? classes.newEngagerCircle6 : index === 2 ? classes.newEngagerCircle7 : index === 3 ? classes.newEngagerCircle8 : index === 4 ? classes.newEngagerCircle9 : ''}`}></span>
                      <span>{data.name}</span>
                    </span>
                  </li>
                )
              })
            }
          </ul>
        </Grid>
        <Grid item>
          <Box className="d-flex align-items-center justify-content-end">
            <Box>
              <Typography className="pagingInfoText">{!toggleNewEngager ? '1-10' : '11-20'} of 20</Typography>
            </Box>
            <Box className="pagingArrow">
              <KeyboardArrowLeftIcon fontSize="small" onClick={this.props.handleNewEngager} className={`${classes.pointer} ${!toggleNewEngager && classes.eventDisable}`}/>
              <KeyboardArrowRightIcon fontSize="small" onClick={this.props.handleNewEngager} className={`${classes.pointer} ${toggleNewEngager && classes.eventDisable}`}/>
            </Box>
          </Box>
        </Grid>
      </Grid>
    )
  }
}
export default withStyles(styles)(AcquisitionRollingComponent)
